import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@xref/xref-lib';
import { BookDemoModalComponent } from './book-demo-modal.component';

@NgModule({
  declarations: [BookDemoModalComponent],
  imports: [CommonModule, ButtonModule],
  exports: [BookDemoModalComponent]
})
export class BookDemoModalModule {}
